export default __webpack_public_path__ + "static/media/login-background.c8ea04f9.png";